import { CognitoUserPool } from 'amazon-cognito-identity-js';

const APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;


const poolData = {
  UserPoolId: USER_POOL_ID,
  ClientId: APP_CLIENT_ID,
  Storage: {
    setItem: (key, value) => {
      document.cookie = `${key}=${value}; SameSite=Strict; Secure; HttpOnly`;
    },
    getItem: (key) => {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [cookieKey, cookieValue] = cookie.trim().split('=');
        if (cookieKey === key) {
          return cookieValue;
        }
      }
      return null;
    },
    removeItem: (key) => {
      document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict; Secure; HttpOnly`;
    }
  }
};

export default new CognitoUserPool(poolData);
